export interface CharsMap {
    readonly [propName: string]: string;
}

const DefaultCharsMap: CharsMap = {
    Š: 'S',
    š: 's',
    Đ: 'Dj',
    đ: 'dj',
    Ž: 'Z',
    ž: 'z',
    Č: 'C',
    č: 'c',
    Ć: 'C',
    ć: 'c',
    À: 'A',
    Á: 'A',
    Â: 'A',
    Ã: 'A',
    Ä: 'A',
    Å: 'A',
    Æ: 'A',
    Ç: 'C',
    È: 'E',
    É: 'E',
    Ê: 'E',
    Ë: 'E',
    Ì: 'I',
    Í: 'I',
    Î: 'I',
    Ï: 'I',
    Ñ: 'N',
    Ò: 'O',
    Ó: 'O',
    Ô: 'O',
    Õ: 'O',
    Ö: 'O',
    Ø: 'O',
    Ù: 'U',
    Ú: 'U',
    Û: 'U',
    Ü: 'U',
    Ý: 'Y',
    Þ: 'B',
    ß: 'Ss',
    à: 'a',
    á: 'a',
    â: 'a',
    ã: 'a',
    ä: 'a',
    å: 'a',
    æ: 'a',
    ç: 'c',
    è: 'e',
    é: 'e',
    ê: 'e',
    ë: 'e',
    ì: 'i',
    í: 'i',
    î: 'i',
    ï: 'i',
    ð: 'o',
    ñ: 'n',
    ò: 'o',
    ó: 'o',
    ô: 'o',
    õ: 'o',
    ö: 'o',
    ø: 'o',
    ù: 'u',
    ú: 'u',
    û: 'u',
    ý: 'y',
    þ: 'b',
    ÿ: 'y',
    Ŕ: 'R',
    ŕ: 'r',
    Ð: 'Dj',
    Ń: 'N',
    ń: 'n',
    ü: 'u',
    ƒ: 'f',
    ă: 'a',
    ș: 's',
    ț: 't',
    Ă: 'A',
    Ș: 'S',
    Ț: 'T',
};

export default class CharsConverter {
    constructor(private readonly charsMap: CharsMap = DefaultCharsMap) {}

    public convertChars(convertable: string): string {
        return Object.values([...convertable])
            .map((char) => {
                return char in this.charsMap ? this.charsMap[char] : char;
            })
            .join('');
    }
}
